import PopularComparisons from './PopularComparisons'

export default PopularComparisons
